window.bkObj = function () {
		function bkObj() { }

		bkObj.loadjQuery = function (afterLoad) {
			return bkObj.loadScript("https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js", function () {
				bkObj.$ = jQuery.noConflict(true);
				return afterLoad();
			});
		};

		bkObj.loadScript = function (url, callback) {
			var script = document.createElement("script");
			script.type = "text/javascript";

			if (script.readyState) {
				script.onreadystatechange = function () {
					if (script.readyState === "loaded" || script.readyState === "complete") {
						script.onreadystatechange = null;
						return callback();
					}
				};
			} else {
				script.onload = function () {
					return callback();
				};
			}

			script.src = url;
			return document.getElementsByTagName("head")[0].appendChild(script);
		};

		return bkObj;
	}(); 

bkObj.loadjQuery(function () {

var hide_qty = false;
$.each($('.cart__meta-text'), function () {
  var obj = $(this);
  var meta_text = obj.text();

  if (meta_text.indexOf('wk_booking') >= 0) {
    hide_qty = true;
    obj.empty();

    if (meta_text.indexOf('October') != -1 && meta_text.indexOf('October') <= meta_text.indexOf('to')) {
      meta_text = meta_text.replace('wk_booking:', '<u>Booking Details</u>,').replace(/{/g, '').replace(/}/g, '').replace(/"/g, '').replace(/=>/g, ': ').replace(/_/g, ' ').replace(/from/, 'slot time ').replace(/to/, 'To').replace(/to/, '').replace(/To/, 'to').replace(/, :/, ' -');
    } else {
      meta_text = meta_text.replace('wk_booking:', '<u>Booking Details</u>,').replace(/{/g, '').replace(/}/g, '').replace(/"/g, '').replace(/=>/g, ': ').replace(/_/g, ' ').replace(/from/, 'slot time ').replace(/to/, '').replace(/, :/, ' -');
    }

    metaArr = meta_text.split(',');
    var objectToAppend = [];
    var configurationType,slotDate,slotTime;
    $.each(metaArr, function (key, value) {
      if(value.indexOf('label') > 0){
        if(value.indexOf('date') > 0)
          slotDate = value.split(':')[1];
        if(value.indexOf('time') > 0)
          slotTime = value.split(':')[1];
      }
      else if (value.indexOf('slots') > 0) configurationType = value.split(':')[1]; else if (value.indexOf('slot') > 0) {
        if (value.split(':')[1] != 0) {
          objectToAppend.push($('<div style="font-size: 14px; margin-bottom: 10px;">' + value + '</div>'));
        }
      }
    });
    objectToAppend.forEach(function (element) {
      if (element[0].innerHTML.indexOf("time") != -1 && configurationType != " day date slots" || element[0].innerHTML.indexOf("date") != -1 && (configurationType == " time slots" || configurationType == " day date slots")){
        element[0].innerHTML = element[0].innerHTML.replace("slot date",slotDate).replace("slot time",slotTime);
        obj.append(element);
      }
    });
    obj.closest('tr').find('.cart__qty-input').prop('readonly', true);
  }
  
})
})
